<div *ngIf="!pane || !pane.userServices else contentBlock">
  <loading-line height="40px" width="100%"></loading-line>
</div>

<ng-template #contentBlock>
  <div class="content">
    <app-filter-content [tabs]="filterTabs" [activeTab]="selectedTab" (onSelect)="onSelectItem($event)"></app-filter-content>

    <div class="content-cards">
      <div *ngFor="let service of userServices; let i = index; trackBy: trackByFn" class="card-wrap">
        <app-user-service-card [service]="service"
                                 [displayMode]="'narrow'"
                                 (openUserServiceInModal)="onToggleUserServiceInModal($event)"
                                 (favoriteChanged)="onFavoriteChanged(i)">
        </app-user-service-card>
      </div>
    </div>

    <loading-line *ngIf="pane.loading" height="40px" width="100%"></loading-line>
    <span inViewport (inViewportAction)='onInViewportBottomChange($event)'></span>

    <ng-container *ngIf="!userServices.length && !pane.loading" [ngTemplateOutlet]="noContentStub"></ng-container>
  </div>
</ng-template>

<ng-template #noContentStub>
  <app-empty [empty]="emptyObj"></app-empty>
</ng-template>

<app-modal *ngIf="deviceService.isDesktop() && userServiceCardFullInModal"
           [canClose]="false"
           (closed)="onToggleUserServiceInModal()">
  <app-modal-body>
    <app-user-service-card-full [userService]="openedUserService"
                                [modal]="true"
                                (inViewportChange)="onIinViewportChange($event)">
    </app-user-service-card-full>
  </app-modal-body>
  <app-modal-ad>
    <ng-template [ngIf]="!surfaceBlockDisplay">
      <app-user-service-surface-block [userService]="openedUserService"></app-user-service-surface-block>
    </ng-template>
  </app-modal-ad>
</app-modal>

<app-mobile-modal *ngIf="!deviceService.isDesktop() && userServiceCardFullInModal"
                  [titleVisible]="true"
                  (closed)="onToggleUserServiceInModal()">
  <app-mobile-modal-body>
    <app-user-service-card-full [userService]="openedUserService"
                                [modal]="true"
                                (inViewportChange)="onIinViewportChange($event)">
    </app-user-service-card-full>
  </app-mobile-modal-body>
  <app-mobile-modal-ad>
    <ng-template [ngIf]="!surfaceBlockDisplay">
      <app-user-service-surface-block [userService]="openedUserService"></app-user-service-surface-block>
    </ng-template>
  </app-mobile-modal-ad>
</app-mobile-modal>
